module.exports = __webpack_public_path__ + "assets/img/mr2.7e64bae6.png";